<template>
  <div class="picker-header">
    <div
      class="selected-data"
      :data-testid="`${testid}-custom-picker-header`"
    >
      {{ label }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PickerHeader',
  props: {
    label: {
      type: String,
      required: true,
    },
    testid: {
      type: String,
      required: true,
    },
  },
})
</script>

<style scoped>
.picker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgb(var(--v-theme-primary)) !important;
  border-color: rgb(var(--v-theme-primary)) !important;
  height: 72px;
  width: 350px;
}

.selected-data {
  font-size: 25px;
  margin: auto 0.5rem auto 0.5rem;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 15px;
}
</style>